import React from 'react';
import PropTypes from 'prop-types';

import useScreenQuery from 'hooks/useScreenQuery';
import cn from 'utils/classnames';

import styles from './AppSlideTab.module.scss';

function AppSlideTab(props) {
  const { activeIndex, listTab, onSetValue } = props;

  const tabRef = React.useRef([]);
  const [tabWidth, setTabWidth] = React.useState(0);
  const [tabLeftValue, setTabLeftValue] = React.useState(0);

  const { isScreenSM } = useScreenQuery();

  const onClickTab = React.useCallback(
    (e) => {
      const { value } = e.target;

      onSetValue(value);
    },
    [onSetValue],
  );

  React.useEffect(() => {
    if (+activeIndex === null) {
      return;
    }

    const currentTab = tabRef.current[activeIndex];
    setTabLeftValue(currentTab?.offsetLeft ?? 0);
    setTabWidth(currentTab?.clientWidth ?? 0);
  }, [activeIndex, isScreenSM]);

  return (
    <div className={styles.Component}>
      <div
        className={styles.Glider}
        style={{ left: tabLeftValue, width: tabWidth }}
      />

      {listTab.map((tab, index) => {
        const isActive = index === activeIndex;

        return (
          <button
            type="button"
            key={tab.name}
            // eslint-disable-next-line no-return-assign
            ref={(elm) => (tabRef.current[index] = elm)}
            value={tab.value}
            className={cn(styles.TabItem, isActive && styles.TabItemActive)}
            onClick={onClickTab}
          >
            {tab.name}
          </button>
        );
      })}
    </div>
  );
}

AppSlideTab.propTypes = {
  activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,

  listTab: PropTypes.instanceOf(Array).isRequired,

  onSetValue: PropTypes.func.isRequired,
};

export default React.memo(AppSlideTab);
